module.exports = __webpack_public_path__ + "img/2_119.7fd7484f.png";